import React from 'react';

import { ACCESS_CODE_LENGTH } from 'screens/WallBoardSetUp/normalizeAccessCode';

import { Box, Boxes, Caret } from './styles';

const SLOTS = Array.from({ length: ACCESS_CODE_LENGTH }, (_, index) => index);

/**
 * A wallboard access code as 5 boxes: where it's shown (the generator) and,
 * under AccessCodeInput, where it's typed, so the two visibly match.
 */
const AccessCodeBoxes = ({
  code,
  activeIndex,
  testId,
  children,
}: {
  code: string;
  // The box the next character goes in, while the input has focus
  activeIndex?: number;
  testId?: string;
  // The input laid over the boxes
  children?: React.ReactNode;
}) => (
  <Boxes data-testid={testId}>
    {SLOTS.map((index) => {
      const char = code[index];
      const isActive = index === activeIndex;
      return (
        <Box key={index} isActive={isActive} isFilled={!!char}>
          {char || (isActive ? <Caret /> : '·')}
        </Box>
      );
    })}
    {children}
  </Boxes>
);

export default AccessCodeBoxes;
